// extracted by mini-css-extract-plugin
var _1 = "DocFlowMappingFileListSlider-moduleitem__BDtAQ FileList-modulefileListItem__AWC2n";
var _2 = "DocFlowMappingFileListSlider-modulelist__giNjk FileList-moduleFileList__c_gL2";
export { _1 as "item", _2 as "list" }
